var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.value ? _vm.trueColor : _vm.falseColor}},[_vm._v(" "+_vm._s(_vm.value ? _vm.trueName : _vm.falseName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }